import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { principalGuard } from './guards/principal.guard';
import { noFreeGuard } from './guards/no-free.guard';

export const routes: Routes = [
  // Rutas públicas (sin autenticación)
  {
    path: '',
    loadComponent: () =>
      import('./componentes/paginas/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./componentes/paginas/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'formulario-alta',
    loadComponent: () =>
      import('./componentes/paginas/administracion/formulario-alta/formulario-alta.component').then(
        (m) => m.FormularioAltaComponent
      ),
  },
  {
    path: 'verificar',
    loadComponent: () =>
      import('./componentes/paginas/administracion/verificar/verificar.component').then(
        (m) => m.VerificarComponent
      ),
  },
  {
    path: 'cambio-contrasena-1',
    loadComponent: () =>
      import('./componentes/paginas/administracion/cambio-contrasena-1/cambio-contrasena-1.component').then(
        (m) => m.CambioContrasena1Component
      ),
  },
  {
    path: 'cambio-contrasena-2/:usuarioUidRecibido/:usuarioEmailRecibido',
    loadComponent: () =>
      import('./componentes/paginas/administracion/cambio-contrasena-2/cambio-contrasena-2.component').then(
        (m) => m.CambioContrasena2Component
      ),
  },
  {
    path: 'mostrar-documento',
    loadComponent: () =>
      import('./componentes/paginas/mostrar-documento/mostrar-documento.component').then(
        (m) => m.MostrarDocumentoComponent
      ),
  },
  {
    path: 'mostrar-documento/:uid_envio',
    loadComponent: () =>
      import('./componentes/paginas/mostrar-documento/mostrar-documento.component').then(
        (m) => m.MostrarDocumentoComponent
      ),
  },
  {
    path: 'liveness',
    loadComponent: () =>
      import('./componentes/paginas/liveness/liveness.component').then((m) => m.LivenessComponent),
  },

  // Rutas protegidas (requieren autenticación)
  {
    path: 'inicio',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./componentes/paginas/inicio/inicio.component').then((m) => m.InicioComponent),
  },
  {
    path: 'perfil',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./componentes/paginas/perfil/perfil.component').then((m) => m.PerfilComponent),
  },
  {
    path: 'configuracion',
    canActivate: [authGuard, principalGuard],
    loadComponent: () =>
      import('./componentes/paginas/configuracion/configuracion.component').then(
        (m) => m.ConfiguracionComponent
      ),
  },
  {
    path: 'facturas',
    canActivate: [authGuard, principalGuard, noFreeGuard],
    loadComponent: () =>
      import('./componentes/paginas/facturas/facturas.component').then((m) => m.FacturasComponent),
  },
  {
    path: 'tokens',
    canActivate: [authGuard, principalGuard],
    loadComponent: () =>
      import('./componentes/paginas/tokens/tokens.component').then((m) => m.TokensComponent),
  },
  {
    path: 'contactos',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./componentes/paginas/contactos/contactos.component').then(
        (m) => m.ContactosComponent
      ),
  },
  {
    path: 'plantillas-listar',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./componentes/paginas/plantillas/plantillas-listar/plantillas-listar.component').then(
        (m) => m.PlantillasListarComponent
      ),
  },
  {
    path: 'plantillas-crear-editar',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./componentes/paginas/plantillas/plantillas-crear-editar/plantillas-crear-editar.component').then(
        (m) => m.PlantillasCrearEditarComponent
      ),
  },
  {
    path: 'plantillas-crear-editar/:idRecibido',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./componentes/paginas/plantillas/plantillas-crear-editar/plantillas-crear-editar.component').then(
        (m) => m.PlantillasCrearEditarComponent
      ),
  },
  {
    path: 'envios-nuevo',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./componentes/paginas/envios/envios-nuevo/envios-nuevo.component').then(
        (m) => m.EnviosNuevoComponent
      ),
  },
  {
    path: 'envios-nuevo/:idPlantillaRecibida',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./componentes/paginas/envios/envios-nuevo/envios-nuevo.component').then(
        (m) => m.EnviosNuevoComponent
      ),
  },
  {
    path: 'envios-consultar',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./componentes/paginas/envios/envios-consultar/envios-consultar.component').then(
        (m) => m.EnviosConsultarComponent
      ),
  },
  {
    path: 'envios-ver/:tipoRecibido/:idRecibido',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./componentes/paginas/envios/envios-ver/envios-ver.component').then(
        (m) => m.EnviosVerComponent
      ),
  },
  {
    path: 'sellar-documento',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./componentes/paginas/sellos-de-tiempo/sellar-documento/sellar-documento.component').then(
        (m) => m.SellarDocumentoComponent
      ),
  },
  {
    path: 'sellos-de-tiempo-consultar',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./componentes/paginas/sellos-de-tiempo/consultar/sellos-de-tiempo-consultar.component').then(
        (m) => m.SelloDeTiempoConsultarComponent
      ),
  },
  {
    path: 'navegacion-certificada',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./componentes/paginas/sellos-de-tiempo/navegacion-certificada/navegacion-certificada.component').then(
        (m) => m.NavegacionCertificadaComponent
      ),
  },
  {
    path: 'stripe',
    canActivate: [authGuard, principalGuard, noFreeGuard],
    loadComponent: () =>
      import('./componentes/paginas/stripe/stripe.component').then((m) => m.StripeComponent),
  },
  {
    path: 'subusuarios',
    canActivate: [authGuard, principalGuard],
    loadComponent: () =>
      import('./componentes/paginas/subusuarios/subusuarios-listar/subusuarios-listar.component').then(
        (m) => m.SubusuariosListarComponent
      ),
  },

  {
    path: 'soporte',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./componentes/paginas/soporte/soporte.component').then((m) => m.SoporteComponent),
  },
  {
    path: 'notificaciones',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./componentes/paginas/notificaciones/notificaciones.component').then(
        (m) => m.NotificacionesComponent
      ),
  },
  {
    path: 'administracion-usuarios',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./componentes/paginas/administracion/usuarios/usuarios.component').then(
        (m) => m.AdministracionUsuariosComponent
      ),
  },
  {
    path: 'administracion-facturas',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./componentes/paginas/administracion/facturas/facturas.component').then(
        (m) => m.AdministracionFacturasComponent
      ),
  },
  {
    path: 'administracion-errores',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./componentes/paginas/administracion/errores/errores.component').then(
        (m) => m.AdministracionErroresComponent
      ),
  },
  {
    path: 'administracion-envios',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./componentes/paginas/administracion/envios/envios.component').then(
        (m) => m.AdministracionEnviosComponent
      ),
  },
  {
    path: 'administracion-sellos-de-tiempo',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./componentes/paginas/administracion/sellos-de-tiempo/sellos-de-tiempo.component').then(
        (m) => m.AdministracionSellosDeTiempoComponent
      ),
  },
  {
    path: 'administracion-soporte',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./componentes/paginas/administracion/soporte/soporte.component').then(
        (m) => m.AdministracionSoporteComponent
      ),
  },
  {
    path: 'administracion-stats',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./componentes/paginas/administracion/stats/stats.component').then(
        (m) => m.StatsComponent
      ),
  },
  {
    path: 'api',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./componentes/paginas/api/api.component').then((m) => m.ApiComponent),
  },
  {
    path: 'editor-pdfme',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./componentes/editor-pdfme/editor-pdfme.component').then(
        (m) => m.EditorPdfmeComponent
      ),
  },

  // Errores
  {
    path: '404',
    loadComponent: () =>
      import('./componentes/paginas/error404/error404.component').then((m) => m.Error404Component),
  },
  {
    path: '**',
    redirectTo: '/404',
  },
];
